import React from 'react';

import { ActionIcon, Tooltip } from '@mantine/core';
import { IconFilterOff } from '@tabler/icons-react';

const ClearFilters = ({ onClick, className }: { onClick: () => void; className?: string }): JSX.Element => {
  return (
    <Tooltip label='Clear filters' className={className}>
      <ActionIcon onClick={onClick}>
        <IconFilterOff />
      </ActionIcon>
    </Tooltip>
  );
};

export default ClearFilters;
